import type { ReactNode } from 'react';

/** The four positions of a trick, as a compact cross in the middle of the table. */
export function TrickArea({
  testid,
  label,
  north,
  west,
  east,
  south,
}: {
  readonly testid: string;
  readonly label: string;
  readonly north: ReactNode;
  readonly west: ReactNode;
  readonly east: ReactNode;
  readonly south: ReactNode;
}) {
  return (
    // biome-ignore lint/a11y/useSemanticElements: a layout grid, named for screen readers; a fieldset would break the grid
    <div
      role="group"
      aria-label={label}
      data-testid={testid}
      className="mx-auto grid w-fit grid-cols-3 grid-rows-3 items-center justify-items-center gap-0 rounded-3xl bg-black/10 p-3 shadow-inner backdrop-blur-sm lg:gap-2 lg:p-5 dark:bg-white/5"
    >
      <span />
      <div className="-mb-12 sm:-mb-14 lg:-mb-20">{north}</div>
      <span />
      <div className="-mr-3 lg:-mr-6">{west}</div>
      <span />
      <div className="-ml-3 lg:-ml-6">{east}</div>
      <span />
      <div className="-mt-12 sm:-mt-14 lg:-mt-20">{south}</div>
      <span />
    </div>
  );
}
